import React from 'react';
//import $ from 'jquery';
import { Link } from 'react-router-dom';
import { BsArrowRight } from "react-icons/bs";
import Img1 from '../../images/Carson Road Project/For Website/POST CONSTRUCTION_.jpg';
import Img2 from '../../images/Carson Road Project/For Website/PRE CONSTRUCTION.jpg';
import Img3 from '../../images/Carson Road Project/For Website/CONSTRUCTION 1.jpg';
import Img4 from '../../images/Carson Road Project/For Website/CONSTRUCTION 2.jpg';
import Img5 from '../../images/Carson Road Project/For Website/CONSTRUCTION 3.jpg';
import Img6 from '../../images/Carson Road Project/PHOTO-2023-09-06-13-00-19.jpg';
import Img7 from '../../images/Carson Road Project/PHOTO-2023-09-06-13-00-19(1).jpg';
import Img8 from '../../images/Carson Road Project/PHOTO-2023-09-06-13-00-19(2).jpg';
import Img9 from '../../images/Carson Road Project/PHOTO-2023-09-06-13-00-19(3).jpg';
import Img10 from '../../images/Carson Road Project/PHOTO-2023-09-06-13-00-19(4).jpg';


export default () => (

	<div className='project-template'>
		<img className='main-project-img' src={Img1} ></img>

		<h4>The Carson Road Project</h4>
		<h5>8 Unit Development</h5>
		<p>Two distinct buildings, each containing 4 versatile units designed to meet Canada's diverse housing needs. The units range from 2 to 4 bedrooms, with top units spanning two stories for added spaciousness. Amenities include outdoor parking, aiming to make daily life convenient and straightforward for residents.</p>
		<div className='project-desc-text' >
			<p class="p1">BUILT 2020 · OTTAWA,ON · BUILDING 1 · 2x - 2 STOREY APARTMENT - 1,230 SQ FT WITH 4 BEDROOMS 2x - BASEMENT APARTMENT - 615 SQ FT WITH 2 BEDROOMS
			</p>
			<p class="p1">BUILT 2020 · OTTAWA,ON · BUILDING 2 · 2x - 2 STOREY APARTMENT - 1,262 SQ FT WITH 4 BEDROOMS 2x - BASEMENT APARTMENT - 631 SQ FT WITH 2 BEDROOMS
			</p>
		</div>
		<Link className="proj-button" to='/contactpage'>
			<button className="projectpage-button">GET IN TOUCH</button>
		</Link>


		<div className="project-split">
			<img className="project-img" src={Img2}></img>
			<img className="project-img" src={Img3}></img>
			<img className="project-img" src={Img4}></img>
			<img className="project-img" src={Img5}></img>
			<img className="project-img" src={Img6}></img>
			<img className="project-img" src={Img7} ></img>
			<img className="project-img" src={Img9}></img>
			<img className="project-img" src={Img10}></img>

		</div>

	</div>


);
